import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=c95388ea&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c95388ea')) {
      api.createRecord('c95388ea', component.options)
    } else {
      api.reload('c95388ea', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=c95388ea&", function () {
      api.rerender('c95388ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UENxzTYrWS7Q/JS/imageCarousel.vue"
export default component.exports